<template>
  <RestoreLogList />
</template>

<script>

import RestoreLogList from '@/components/common/audit/RestoreLogList.vue';

export default {
  name: 'RestoreLog',
  components: {
    RestoreLogList,
  },
};
</script>
